import { InsightCatalogue } from '../InsightCatalogue';
import {
  FullInsightPayload,
  BaseInsightPayload,
  InsightMetric,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface UsersTypePayload extends FullInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_USERS_TYPE;
    id: string;
    attributes: {
      data: Array<{
        user_type: string;
        user_count: number;
      }>;
      aggregate: {
        total_users: InsightMetric;
      };
    };
  };
}

export const parseUsersTypePayload = (
  payload: BaseInsightPayload
): UsersTypePayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_USERS_TYPE,
    data.attributes,
    true,
    true
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    data: Array<{
      user_type: string;
      user_count: number;
    }>;
    aggregate: {
      total_users: InsightMetric;
    };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_USERS_TYPE,
      id: data.id,
      attributes: {
        data: typedAttributes.data,
        aggregate: {
          total_users: typedAttributes.aggregate.total_users,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
